import styled from "styled-components"
import { Link } from "react-router-dom"
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import { FaFacebook } from 'react-icons/fa'
import { AiFillGoogleCircle } from 'react-icons/ai'

export const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.35);
    z-index: 99;
    opacity: ${({open}) => open?'1':'0'};
    visibility: ${({open}) => open?'visible':'hidden'};
    transition: all .3s ease;
`

export const FormWrap = styled.div`
    box-shadow: 0 2px 26px rgb(0 0 0 / 30%), 0 0 0 1px rgb(0 0 0 / 10%);
    width: 630px;
    margin-top: 60px;
    z-index: 100;
    background-color: #fff;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    opacity: ${({open}) => open?'1':'0'};
    visibility: ${({open}) => open?'visible':'hidden'};
    transition: all .3s ease;
    border-radius: 2px;
    overflow: hidden;

    @media screen and (max-width: 767px) {
        width: 100%;
        overflow: auto;
        margin-top: 0;
        height: 100vh;
    }
`

export const FormHeader = styled.div``

export const FormNav = styled.ul`
    list-style: none;
    display: flex;
    background-color: #f3f3f3;
`
export const NavItem = styled.li`
    &:last-child {
        margin-left: auto;

        a {
            padding: 14.5px;
            font-weight: 400;

            &:hover {
                color: #222;
                background-color: transparent;
            }
        }
    }
`

export const NavLink = styled(Link)`
    text-decoration: none;
    font-size: 16px;
    font-weight: bold;
    padding: 14px 24px;
    display: flex;
    align-items: center;
    color: #222;
    line-height: 1.3;

    &.active {
        color: #495057;
        background-color: #fff;
    }

    &:hover {
        color: #495057;
        background-color: #fff;
    }

    @media screen and (max-width: 374px) {
        font-size: 14px;
        padding: 14px 12px;
    }
`

export const UserIcon = styled(PersonOutlineIcon)`
    font-size: 16px;
    position: relative;
    top: -1px;
    margin-right: 1px;
`
export const GoogleIcon = styled(AiFillGoogleCircle)`
    color: #DB2914;
    font-size: 48px;

    &:hover {
        color: #ac2925;
    }
`

export const FacebookIcon = styled(FaFacebook)`
    font-size: 44px;
    color: #3B5A9B;

    &:hover {
        color: #0069d9;
    }
`

export const FormFooter = styled.div`
    background-color: #f2f2f2;
    padding: 24px 100px;
    padding-bottom: 24px ;
    display: flex;
    align-items: center;
    flex-direction: column;

    @media screen and (max-width: 767px) {
        padding: 12px 60px;
    }
`

export const FormFooterText = styled.p`
    font-size: 14px;
    opacity: .7;
    color: #222;
    padding-bottom: 8px;
    font-weight: bold;
    line-height: 1.43;
`

export const Social = styled.div`
    display: flex;
    align-items: center;
`

export const SocialLogin = styled(Link)`
    text-decoration: none;

    &:first-child {
        margin-right: 8px;
    }
`
export const FormBody = styled.div`
    padding: 38px 100px 12px;

    @media screen and (max-width: 767px) {
        padding: 20px 12px 12px;
    }
`
export const FormGroup = styled.div`
    margin-bottom: 12px;

    &.flex-between {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;
    }

    @media screen and (max-width: 767px) {
        &.mb-col {
            flex-direction: column;
        }
    }
`
export const TextUnderline = styled(Link)`
    font-size: 14px;
    color: #222;
    padding: 6px 12px 6px 0;
    text-decoration: none;
    white-space: nowrap;

    &:hover {
        text-decoration: underline;
    }

    @media screen and (max-width: 767px) {
        order: 1;
        margin-top: 12px;

        &.wrap {
            white-space: normal;
        }
    }
`

export const FormSubmit = styled.button`
    outline: none;
    width: 134px;
    background-color: #e32;
    border: none;
    padding: 9px;
    font-size: 14px;
    user-select: none;
    border-radius: 2px;
    line-height: 1.4;
    color: #fff;
    cursor: pointer;
    
    &:hover {
        background-color: #ac2925;
        border-color: #761c19;
    }

    @media screen and (max-width: 767px) {
        order: 0;
        width: 100%;
    }
`
